// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "blocked_time".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "blocked_time" table (1:1 with a DB row, on the wire). */
export const blockedTimeAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    blockedTimeTypeId: z.string().nullable(),
    locationId: z.string().nullable(),
    title: z.string(),
    description: z.string().nullable(),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    allDay: z.boolean(),
    timezone: z.string(),
    rrule: z.string().nullable(),
    recurrenceEndDate: z.string().datetime().nullable(),
    paid: z.boolean(),
    calendarAccountId: z.string().nullable(),
    externalCalendarEventId: z.string().nullable(),
    externalCalendarEtag: z.string().nullable(),
    importedFromGoogle: z.boolean(),
    calendarSourceId: z.string().nullable(),
    externalSourceEventId: z.string().nullable(),
    externalSourceUpdatedAt: z.string().datetime().nullable(),
    blocksAvailability: z.boolean(),
    createdById: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=blockedTime.js.map